export default __webpack_public_path__ + "static/media/TotalStudentsIcon.4a867322.svg";